import React, { useState } from 'react';
import T from '../common/T';
import { User, Phone, Wallet, Building2, Trash2, CheckCircle, Layers } from 'lucide-react';
import { useCRM } from '../../context/CRMContext';

// 🟢 FIX 1: Defined Component OUTSIDE to prevent re-render focus loss
const InputRow = ({ icon: Icon, name, placeholder, value, onChange, type = "text", required = false, autoFocus = false }) => (
  <div className={`flex items-center gap-3 border-b ${required ? 'border-purple-300' : 'border-gray-200'} py-1.5`}>
    <Icon size={16} className="text-gray-400 w-5" />
    <input
      type={type}
      name={name}
      placeholder={placeholder}
      value={value} // Controlled input
      onChange={onChange}
      className={`flex-1 bg-transparent outline-none text-sm text-gray-700 placeholder-gray-400 ${required ? 'font-medium' : ''}`}
      autoFocus={autoFocus}
    />
  </div>
);

const QuickAddCard = () => {
  const { addNewLead, setIsQuickAddVisible } = useCRM();
  
  const [priority, setPriority] = useState('medium');
  const [formData, setFormData] = useState({
    clientName: '',
    phone: '',
    interestedUnit: '', 
    configuration: '3 BHK', // Default Option
    budget: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    if (!formData.clientName.trim()) {
      alert("Client Name is required.");
      return;
    }
    
    // Combine Config + Unit for the title (e.g., "3 BHK - A-402")
    const unitTitle = formData.interestedUnit 
      ? `${formData.configuration} - ${formData.interestedUnit}`
      : `${formData.configuration} Inquiry`;

    addNewLead({ 
        opportunityName: `${formData.clientName} - ${unitTitle}`,
        company: formData.clientName,
        phone: formData.phone,
        expectedRevenue: formData.budget, 
        contact: formData.clientName,
        priority,
        // Pass extra data so it shows up in Detail View
        unit: formData.interestedUnit,
        configuration: formData.configuration 
    });
  };

  return (
    <div className="bg-white p-3 mb-3 rounded-lg shadow-lg border border-gray-200 animate-in fade-in slide-in-from-top-2 duration-200 ring-1 ring-purple-100">
      
      <div className="space-y-1 mb-3">
        {/* Client Name */}
        <InputRow 
            icon={User} 
            name="clientName" 
            placeholder="Client Name *" 
            value={formData.clientName}
            onChange={handleInputChange}
            required 
            autoFocus 
        />
        
        {/* Phone */}
        <InputRow 
            icon={Phone} 
            name="phone" 
            placeholder="Mobile Number" 
            value={formData.phone}
            onChange={handleInputChange}
        />

        {/* 🟢 NEW: Unit Type Selection (Dropdown) */}
        <div className="flex items-center gap-3 border-b border-gray-200 py-1.5">
            <Layers size={16} className="text-gray-400 w-5" />
            <select 
                name="configuration" 
                value={formData.configuration} 
                onChange={handleInputChange}
                className="flex-1 bg-transparent outline-none text-sm text-gray-700 cursor-pointer"
            >
                <option value="2 BHK"><T>2 BHK</T></option>
                <option value="3 BHK"><T>3 BHK</T></option>
                <option value="Penthouse"><T>Penthouse</T></option>
                <option value="Shop"><T>Shop</T></option>
                <option value="Office"><T>Office</T></option>
            </select>
        </div>

        {/* Interested Unit (Specific Number) */}
        <InputRow 
            icon={Building2} 
            name="interestedUnit" 
            placeholder="Unit No. (e.g. A-402)" 
            value={formData.interestedUnit}
            onChange={handleInputChange}
        />
        
        {/* Budget (Focus Issue Fixed) */}
        <InputRow 
            icon={Wallet} 
            name="budget" 
            placeholder="Budget (₹)" 
            type="number" 
            value={formData.budget}
            onChange={handleInputChange}
        />
      </div>

      {/* Footer Buttons */}
      <div className="flex justify-between items-center pt-2 mt-1 border-t border-gray-50">
        <div className="flex gap-2">
          <button onClick={handleAdd} className="bg-purple-700 text-white px-3 py-1.5 rounded-md text-xs font-bold hover:bg-purple-800 shadow-sm uppercase flex items-center gap-1">
            <CheckCircle size={14} /> Add
          </button>
        </div>
        <button onClick={() => setIsQuickAddVisible(false)} className="text-gray-400 hover:text-red-500 p-1 hover:bg-red-50 rounded transition">
            <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
};

export default QuickAddCard;